import { render, staticRenderFns } from "./SearchRecord.vue?vue&type=template&id=1e586d95"
import script from "./SearchRecord.vue?vue&type=script&lang=js"
export * from "./SearchRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports